import { render } from "./RequestIntern.vue?vue&type=template&id=0f2dcfc5"
import script from "./RequestIntern.vue?vue&type=script&lang=js"
export * from "./RequestIntern.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__